export default __webpack_public_path__ + "static/media/s3-002.1d6a10ff.png";